import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { CircularProgress } from '@mui/material';
import { GridActionsCellItem, Table } from '../../components/table/Table';

export default function SoilPointsTable(props) {
  const { onRejectClick, soilPoints, attributes } = props;

  return (
    <Table
      density="compact"
      getRowId={(row) => row.objectId}
      getCellClassName={({ field, row }) => row.qcFlags[field]}
      initialState={{
        sorting: {
          sortModel: [{ field: 'objectId', sort: 'asc' }],
        },
        columns: {
          columnVisibilityModel: {
            objectId: false,
          },
        },
      }}
      columns={[
        {
          field: 'objectId',
          headerName: 'ID',
          hide: true,
        },
        {
          field: 'collectionDate',
          headerName: 'Date',
          valueFormatter: ({ value }) =>
            value &&
            new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' }).format(
              new Date(value),
            ),
          flex: 0.75,
        },
        ...Object.entries(attributes).map(([field, config]) => ({
          field,
          type: 'number',
          headerName: config.header,
          headerAlign: 'right',
          align: 'right',
          flex: 0.5,
          valueFormatter: ({ value }) => value?.toFixed(config.decimals),
        })),
        {
          field: 'actions',
          type: 'actions',
          headerName: 'Reject',
          getActions: ({ row }) => [
            <GridActionsCellItem
              disabled={row.isRejecting}
              onClick={() => onRejectClick(row)}
              icon={
                row.isRejecting ? (
                  <CircularProgress size={14} />
                ) : (
                  <DeleteIcon />
                )
              }
              label="Reject"
            />,
          ],
        },
      ]}
      rows={soilPoints}
    />
  );
}
